import { z } from "zod";

export const jobPostingSchema = z.object({
  id: z.number().int(),
  externalId: z.string(),
  sourceName: z.string(),
  title: z.string(),
  company: z.string().nullable().optional(),
  location: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  url: z.string().nullable().optional(),
  firstSeenAt: z.string(),
  lastSeenAt: z.string(),
  isActive: z.boolean(),
});

export const jobPostingQueryRequestSchema = z.object({
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().default(30),
  sourceName: z.string().optional().nullable(),
  location: z.string().optional().nullable(),
  company: z.string().optional().nullable(),
  isActive: z.boolean().optional().nullable(),
  searchTerm: z.array(z.string().max(255)).optional().nullable(),
  searchFields: z.array(z.enum(["Title", "Company", "Location", "Description"])).optional().nullable(),
  sortBy: z.string().optional().nullable(),
  sortDirection: z.string().default("DESC"),
});

export const jobPostingQueryResponseSchema = z.object({
  items: z.array(jobPostingSchema),
  totalCount: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
  totalPages: z.number().int(),
});

export const jobPostingFiltersResponseSchema = z.object({
  sources: z.array(z.string()),
  locations: z.array(z.string()),
  companies: z.array(z.string()),
});

export const jobPostingStatsSchema = z.object({
  totalCount: z.number().int(),
  activeCount: z.number().int(),
  inactiveCount: z.number().int(),
});

export const crawlRunSchema = z.object({
  id: z.number().int(),
  sourceName: z.string(),
  startedAt: z.string(),
  completedAt: z.string().nullable().optional(),
  status: z.string(),
  newPostings: z.number().int(),
  updatedPostings: z.number().int(),
  deactivatedPostings: z.number().int(),
  errorMessage: z.string().nullable().optional(),
  triggeredBy: z.string().nullable().optional(),
  queryFiltersJson: z.string().nullable().optional(),
});

export const jobSearchFiltersSchema = z.object({
  companyUrl: z.string().optional(),
  companyName: z.string().optional(),
  title: z.array(z.string()).optional(),
  description: z.array(z.string()).optional(),
  location: z.string().optional(),
  country: z.string().optional(),
  seniority: z.string().optional(),
  employmentType: z.string().optional(),
  activeOnly: z.boolean().optional(),
  postedAfter: z.string().optional(),
});

export const previewJobSearchRequestSchema = z.object({
  filters: jobSearchFiltersSchema,
  itemsPerPage: z.number().int().optional(),
});

export const importJobPostingsRequestSchema = z.object({
  filters: jobSearchFiltersSchema,
});

export const previewJobPostingSchema = z.object({
  id: z.number(),
  title: z.string().nullable().optional(),
  companyName: z.string().nullable().optional(),
  location: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  score: z.number().nullable().optional(),
});

export const previewJobSearchResponseSchema = z.object({
  totalCount: z.number().int(),
  remainingCredits: z.number().int().nullable().optional(),
  jobPostings: z.array(previewJobPostingSchema),
});
